function delegateEvent(eventName, elementSelector, handler) {
  document.addEventListener(eventName, (e) => {
    for(let { target } = e; target && target != this; target = target.parentNode) {
      if(target instanceof Element && target.matches(elementSelector)){
        handler(target);
        break;
      }
    }
  })
}

function addMobileAnimation(elementSelector ,className){
    delegateEvent('touchstart', elementSelector, (target) => {
        target.classList.add(className)
    });
    delegateEvent('touchend', elementSelector, (target) => {
      target.classList.remove(className)
  });
}


document.addEventListener('DOMContentLoaded', () => {
  if(window.innerWidth > 989){
    return;
  }
  addMobileAnimation('.offer__item', 'rotate-icon');
})